import { render, staticRenderFns } from "./neewerai.vue?vue&type=template&id=d71c1b36&scoped=true"
import script from "./neewerai.vue?vue&type=script&lang=js"
export * from "./neewerai.vue?vue&type=script&lang=js"
import style0 from "./neewerai.vue?vue&type=style&index=0&id=d71c1b36&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71c1b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d71c1b36')) {
      api.createRecord('d71c1b36', component.options)
    } else {
      api.reload('d71c1b36', component.options)
    }
    module.hot.accept("./neewerai.vue?vue&type=template&id=d71c1b36&scoped=true", function () {
      api.rerender('d71c1b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/neewerdownload/neewerai.vue"
export default component.exports